<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <!--    <section v-else-if="userIsEmpty('user')">-->
    <!--        <div class="no-auth">-->
    <!--            Вы не авторизованы! Пожалуйста, <router-link class="link" tag='a' :to="{ name: 'home'}">войдите или зарегистрируйтесь</router-link>-->
    <!--        </div>-->
    <!--    </section>-->
    <section v-else-if="!profileIsEmpty('profile')" class="profile">
        <div class="profile-header">
            <div class="profile-header-inner container-mobile">
                <div class="profile-avatar">
                    <div @click="$modal.show('image-details', { image: profile.avatar })" :style="{
                        'background-image': profile.avatar
                            ? 'url(' + profile.avatar + ')'
                            : '',
                    }" class="profile-avatar-inner" :class="{ 'no-avatar': !profile.avatar }"></div>
                    <div v-if="id == user.id && profile.avatar" @click="$modal.show('upload-avatar')"
                        class="profile-change-avatar">
                        <span class="profile-change-avatar-inner"><span>
                                {{ $t("profile.changeAvatar") }}
                            </span>
                        </span>
                    </div>
                    <div v-if="id == user.id && !profile.avatar" @click="$modal.show('upload-avatar')"
                        class="profile-upload-avatar">
                        <span>
                            {{ $t("profile.add") }}
                        </span>
                        <span>
                            {{ $t("profile.avatar") }}
                        </span>
                    </div>
                </div>
                <div v-if="id != user.id && profile.status" class="profile-status">
                    <div class="profile-status-inner">{{ profile.status }}</div>
                </div>
                <div v-if="id == user.id" v-click-outside="{ handler: 'saveStatus' }" class="profile-status" :class="{
                    'profile-status-edit': statusEdit,
                    'profile-status-empty': !localStatus.status && !statusEdit,
                }">
                    <div v-if="!localStatus.status && !statusEdit" class="profile-status-add">
                        {{ $t("profile.writeStatus") }}
                    </div>
                    <textarea v-model="localStatus.status" @input="updated($event)" @change="updated($event)"
                        @focus="clickInsideStatus" id="status" :maxlength="100" class="textarea"></textarea>
                </div>
                <div class="profile-personal">
                    <div class="profile-name">
                        <span class="name">{{ profile.first_name }}</span>
                        {{ profile.last_name }}
                    </div>
                    <div v-if="profile.birthday.length == 10 ||
                        profile.city ||
                        profile.birthday != $t('profile.hidden')
                        " class="profile-header-bottom">
                        <span v-if="profile.birthday.length == 10">
                            {{ age }}
                            {{
                                declineNouns(age, [
                                    $t("photos.year"),
                                    $t("photos.ofTheYear"),
                                    $t("photos.years"),

                                ])
                            }},
                        </span>
                        <span v-if="profile.city" class="profile-city">{{
                            profile.city
                        }}</span><span v-if="profile.city && profile.birthday != $t('profile.hidden')">,</span>
                        <span v-if="profile.birthday != $t('profile.hidden')">{{
                            zodiac
                        }}</span>
                    </div>
                    <div v-if="profile.online" class="profile-online profile-online-mobile">
                        {{ $t("profile.online") }}
                    </div>
                    <div v-else class="profile-online profile-last-online profile-online-mobile">
                        {{ $t("profile.was") }}
                        <span v-if="profile.gender == $t('profile.womens')">
                            {{ $t("profile.a") }}
                        </span>
                        {{ getShortDMY(profile.last_online * 1000) }}
                        {{ $t("profile.in") }}
                        {{ getHM(profile.last_online * 1000) }}
                    </div>
                </div>
                <div v-if="profile.vip" class="profile-vip"></div>
                <div v-if="profile.online" class="profile-online profile-online-desktop">
                    {{ $t("profile.online") }}
                </div>

                <div v-else class="profile-online profile-last-online profile-online-desktop">


                    <span v-if="profile.gender !== $t('profile.womens')">
                        {{ $t("profile.was") }}
                    </span>
                    <span v-if="profile.gender == $t('profile.womens')">
                        {{ $t("profile.was") }}{{ $t("profile.a") }}
                    </span>

                    {{ this.getShortDMY(profile.last_online * 1000) }}
                    {{ $t("profile.in") }}
                    {{ this.getHM(profile.last_online * 1000) }}
                </div>

            </div>
        </div>

        <div class="profile-body container-mobile">
            <div class="profile-row">
                <div v-if="id == user.id" class="profile-actions profile-actions-my">
                    <button v-if="profile.vip" @click="$modal.show('vip-buy')" class="button">
                        {{ $t("profile.extend") }}
                        <b>
                            {{ $t("profile.vipAccount") }}
                        </b>
                    </button>
                    <button v-if="!profile.vip" @click="$modal.show('vip-buy')" class="button">
                        {{ $t("profile.buy") }}
                        <b>
                            {{ $t("profile.vipAccount") }}
                        </b>
                    </button>
                    <router-link :to="{ name: 'profile-edit' }" class="link-underlined">
                        {{ $t("profile.editQuestionnaire") }}
                    </router-link>
                </div>

                <div v-if="id != user.id" class="profile-actions">
                    <button v-if="profile.vip &&
                        profile.vip_settings.invites == 1 &&
                        profile.is_friend.type != 2 &&
                        !user.vip
                        " disabled ref="gamesButton" class="button">
                        {{ $t("profile.inviteToGame") }}
                    </button>
                    <button v-else @click="showGames = !showGames" ref="gamesButton" class="button">
                        {{ $t("profile.inviteToTheGame") }}
                    </button>
                    <InviteToGame v-if="showGames" v-click-outside="{
                        exclude: ['gamesButton'],
                        handler: 'clickOutsideGames',
                    }" :id="id" class="profile-games invite"></InviteToGame>
                    <button @click="sendMessage(id)" class="button-secondary button-chat">
                        {{ $t("profile.openChat") }}
                    </button>
                    <div class="profile-actions-row">
                        <button @click="sendGift" class="button-secondary button-friends">
                            {{ $t("profile.sendGift") }}
                        </button>
                        <button @click="showContext = !showContext" ref="contextButton"
                            class="button-secondary context-opener"></button>
                        <ul v-if="showContext" v-click-outside="{
                            exclude: ['contextButton'],
                            handler: 'clickOutsideContext',
                        }" class="profile-context">
                            <li class="profile-context-item">
                                <span @click="sendMessage(id)">
                                    {{ $t("profile.writeMessage") }}
                                </span>
                            </li>
                            <li v-if="profile.is_friend.type == 0" @click="addToFriends" class="profile-context-item"
                                :class="{ 'context-item-loader': friendsLoader }">
                                {{ $t("profile.addAsFriend") }}
                            </li>
                            <li v-if="profile.is_friend.type == 1" @click="cancelAddFriends" class="profile-context-item"
                                :class="{ 'context-item-loader': friendsLoader }">
                                {{ $t("profile.cancelRequest") }}
                            </li>
                            <li v-if="profile.is_friend.type == 2" @click="removeFriend" class="profile-context-item"
                                :class="{ 'context-item-loader': friendsLoader }">
                                {{ $t("profile.removeFromFriends") }}
                            </li>
                            <li v-if="profile.is_friend.type == 3" @click="acceptFriend" class="profile-context-item"
                                :class="{ 'context-item-loader': friendsLoader }">
                                {{ $t("profile.confirmFriendship") }}
                            </li>
                            <li v-if="profile.is_blocked.type == 0" @click="blacklist(true)" class="profile-context-item"
                                :class="{ disabled: blacklistLoader || !user.vip }">
                                {{ $t("profile.addBlacklist") }}
                                <span v-if="!user.vip"> ({{ $t("profile.vipOnly") }}) </span>
                            </li>
                            <li v-if="profile.is_blocked.type == 1" @click="blacklist(false)" class="profile-context-item"
                                :class="{ disabled: blacklistLoader || !user.vip }">
                                {{ $t("profile.removeFromBlacklist") }}
                                <span v-if="!user.vip">({{ $t("profile.vipOnly") }})</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="profile-gifts info-block">
                    <div class="section-header">
                        <span @click="$modal.show('my-gifts', { id: id })" class="profile-gifts-title">
                            {{ $t("profile.gifts") }}
                            <span class="count">{{ giftsCount }}</span>
                        </span>
                        <span v-if="!giftsIsEmpty('userGifts')" @click="
                            $modal.show('my-gifts', {
                                id: id,
                                name: profile.first_name + ' ' + profile.last_name,
                            })
                            " class="link">
                            {{ $t("profile.showAll") }}
                        </span>
                    </div>
                    <div v-if="giftsIsEmpty('userGifts')" class="profile-gifts-empty">
                        <span v-if="id == user.id">
                            {{ $t("profile.youGiftsYet") }}
                        </span>
                        <span v-else>
                            {{ $t("profile.userDoesGiftsYet") }}
                        </span>
                    </div>
                    <ul v-else class="profile-gifts-row">
                        <li v-for="gift in userGifts" :key="gift.id" @click="
                            $modal.show('my-gifts', {
                                id: id,
                                gift: gift,
                            })
                            " class="profile-gifts-item">
                            <img :src="gift.image" :alt="gift.name" class="profile-gifts-inner" />
                        </li>
                    </ul>
                </div>
            </div>
            <ProfileMedia :id="id" type="photos"></ProfileMedia>
            <ProfileMedia :id="id" type="videos"></ProfileMedia>
            <ProfilePuzzles v-if="id == user.id"></ProfilePuzzles>
            <div v-if="!userIsEmpty('user')" class="profile-friends info-block">
                <div class="section-header">
                    <h2>
                        {{ $t("profile.friends") }}
                        <span v-if="friendsCount > 0" class="count">{{
                            friendsCount
                        }}</span>
                    </h2>
                    <router-link v-if="id == user.id && friendsCount > 0" :to="{ name: 'my_friends' }" class="link">
                        {{ $t("profile.viewAllFriends") }}
                    </router-link>
                    <router-link v-else-if="friendsCount > 0" :to="{ name: 'friends', params: { id: id } }" class="link">
                        {{ $t("profile.viewAllFriends") }}
                    </router-link>
                </div>
                <div v-if="friendsLoader" class="buttons-center">
                    <button class="button-loader"></button>
                </div>
                <!-- <div
                    v-else-if="friendsErrors.vip_settings"
                >Просмотр друзей доступен только для друзей и VIP.</div> -->
                <ul v-else-if="!friendsIsEmpty('friends')" class="profile-friends-row">
                    <!-- <router-link
            v-for="(friend, index) in friends"
            :key="friend.id"
            v-if="index < 9"
            tag="li"
            :to="{ name: 'profile', params: { id: friend.id } }"
            class="profile-friends-item"
          > -->
                    <router-link v-for="(friend, index) in limitedFriends" :key="index" tag="li"
                        :to="{ name: 'profile', params: { id: friend.id } }" class="profile-friends-item">
                        <a class="profile-friends-link">
                            <div :style="{
                                'background-image': friend.avatar
                                    ? 'url(' + friend.avatar + ')'
                                    : '',
                            }" class="profile-friends-avatar" :class="{ 'no-avatar': !friend.avatar }"></div>
                            <div class="profile-friends-name link">
                                {{ friend.name.slice(0, friend.name.indexOf(" ")) }}
                            </div>
                        </a>
                    </router-link>
                </ul>
                <div v-else-if="id == user.id">
                    <router-link :to="{ name: 'search' }" class="profile-friends-search">
                        <span class="link-blue-underlined">
                            {{ $t("profile.viewAllFriends") }}
                        </span>
                    </router-link>
                </div>
                <div v-else class="text">
                    {{ $t("profile.friendsListEmpty") }}
                </div>
            </div>
            <div v-if="id == user.id" class="profile-friends info-block">
                <div class="section-header">
                    <h2>
                        {{ $t("profile.guests") }}
                        <span v-if="guestsCount > 0" class="count">{{ guestsCount }}</span>
                    </h2>
                    <router-link v-if="guestsCount > 0" :to="{ name: 'guests' }" class="link">
                        {{ $t("profile.viewAllGuests") }}
                    </router-link>
                </div>
                <div v-if="guestsLoader" class="buttons-center">
                    <button class="button-loader"></button>
                </div>
                <div v-else-if="!this.user.vip" class="profile-guests">
                    <div class="profile-guests-forbidden">
                        {{ $t("profile.thisUsersVipStatus") }}
                    </div>
                    <button @click="$modal.show('vip-buy')" class="button profile-guests-forbidden-button">
                        {{ $t("profile.buy") }}
                        <b>
                            {{ $t("profile.vipAccount") }}
                        </b>
                    </button>
                </div>
                <ul v-else-if="!guestsIsEmpty('guests')" class="profile-friends-row">
                    <!-- <router-link
            v-for="(guest, index) in guests"
            :key="guest.id"
            v-if="index < 9"
            tag="li"
            :to="{ name: 'profile', params: { id: guest.id } }"
            class="profile-friends-item"
          > -->
                    <router-link v-for="(guest, index) in limitedGuests" :key="index" tag="li"
                        :to="{ name: 'profile', params: { id: guest.id } }" class="profile-friends-item">
                        <a class="profile-friends-link">
                            <div :style="{
                                'background-image': guest.avatar
                                    ? 'url(' + guest.avatar + ')'
                                    : '',
                            }" class="profile-friends-avatar" :class="{ 'no-avatar': !guest.avatar }"></div>
                            <div class="profile-friends-name link">
                                {{ guest.name.slice(0, guest.name.indexOf(" ")) }}
                            </div>
                        </a>
                    </router-link>
                </ul>
                <div v-else>
                    {{ $t("profile.theGuestListEmpty") }}
                </div>
            </div>

            <div v-if="id == user.id ||
                profile.birthday != $t('profile.hidden') ||
                profile.family_status ||
                profile.gender ||
                profile.languages.length ||
                profile.city ||
                profile.about ||
                profile.education ||
                profile.height ||
                profile.weight ||
                profile.body_type ||
                profile.amount_of_children ||
                profile.acquaintance_goal ||
                profile.smoking ||
                profile.alcohol
                " class="profile-info info-block">
                <div class="section-header">
                    <h2>
                        {{ $t("profile.questionnaire") }}
                    </h2>
                </div>
                <ul v-if="profile.city ||
                    profile.birthday != $t('profile.hidden') ||
                    profile.family_status ||
                    profile.education
                    " class="profile-info-list profile-info-main">
                    <li v-if="profile.birthday != $t('profile.hidden')" class="profile-info-item">
                        <div class="property">{{ $t("profile.dateBirth") }}:</div>



                        <div class="value" v-if="profile.birthday === 'Скрыто'">{{ $t("profile.hidden") }}</div>
                        <div class="value" v-else>{{ profile.birthday }}</div>

                    </li>
                    <li v-if="profile.city" class="profile-info-item">
                        <div class="property">
                            {{ $t("profile.city") }}
                            :
                        </div>
                        <div class="value">{{ profile.city }}</div>
                    </li>
                    <li v-if="profile.education" class="profile-info-item">
                        <div class="property">
                            {{ $t("profile.education") }}
                        </div>

                        <div class="value" v-if="profile.education === 'среднее'">
                            {{ $t("profileEdit.average") }}
                        </div>
                        <div class="value" v-else-if="profile.education === 'среднее специальное'">
                            {{ $t("profileEdit.secondarySpecialised") }}
                        </div>
                        <div class="value" v-else-if="profile.education === 'неполное высшее'">
                            {{ $t("profileEdit.incompleteHigherEducation") }}
                        </div>
                        <div class="value" v-else-if="profile.education === 'высшее'">
                            {{ $t("profileEdit.higherEducation") }}
                        </div>
                        <div class="value" v-else-if="profile.education === 'два или более высших'">
                            {{ $t("profileEdit.twoMoreUniversity") }}
                        </div>

                    </li>

                    <li v-if="profile.family_status" class="profile-info-item">
                        <div class="property">{{ $t("profile.maritalStatus") }}:</div>

                        <div class="value" v-if="profile.family_status === 'Не замужем'">
                            {{ $t("profileEdit.singleUnmarried") }}
                        </div>

                        <div class="value" v-else-if="profile.family_status === 'Встречаюсь'">
                            {{ $t("profileEdit.dating") }}
                        </div>

                        <div class="value" v-else-if="profile.family_status === 'Помолвлен'">
                            {{ $t("profileEdit.engagedM") }}
                        </div>
                        <div class="value" v-else-if="profile.family_status === 'Помолвлена'">
                            {{ $t("profileEdit.engagedJ") }}
                        </div>

                        <div class="value" v-else-if="profile.family_status === 'Замужем'">
                            {{ $t("profileEdit.marriedG") }}
                        </div>
                        <div class="value" v-else-if="profile.family_status === 'Женат'">
                            {{ $t("profileEdit.marriedM") }}
                        </div>

                        <div class="value" v-else-if="profile.family_status === 'В гражданском браке'">
                            {{ $t("profileEdit.commonMarriage") }}
                        </div>
                    </li>
                </ul>

                <router-link v-if="id == user.id &&
                    !profile.city &&
                    profile.birthday == $t('profile.hidden') &&
                    !profile.family_status &&
                    !profile.education
                    " :to="{ name: 'profile-edit' }" class="link-inherit profile-info-empty profile-info-main">
                    <span class="link-blue-underlined">
                        {{ $t("profile.fillOutForm") }}
                    </span>
                </router-link>
                <div v-if="profile.gender ||
                    profile.languages.length ||
                    profile.about ||
                    profile.height ||
                    profile.weight ||
                    profile.body_type ||
                    profile.amount_of_children ||
                    profile.acquaintance_goal ||
                    profile.smoking ||
                    profile.alcohol
                    " class="profile-info-show-all">
                    <span @click="showInfoAll = !showInfoAll" class="link">
                        <span v-if="showInfoAll">
                            {{ $t("profile.hideDetailedInformation") }}
                        </span>
                        <span v-else>
                            {{ $t("profile.showDetails") }}
                        </span>
                    </span>
                </div>
                <ul v-if="showInfoAll" class="profile-info-list profile-info-all">

                    <li v-if="profile.gender" class="profile-info-item">
                        <div class="property">{{ $t("profile.gender") }}:</div>

                        <div class="value" v-if="profile.gender === 'Мужской'">
                            {{ $t("firstLogin.genderMan") }}
                        </div>

                        <div class="value" v-else-if="profile.gender === 'Женский'">
                            {{ $t("firstLogin.genderWoman") }}
                        </div>

                    </li>

                    <li v-if="profile.height" class="profile-info-item">
                        <div class="property">{{ $t("profile.growth") }}:</div>
                        <!-- <div class="value">{{ profile.height }}</div> -->
                        <div class="value" v-if="profile.height === 'низкий'">
                            {{ $t("profileEdit.low") }}
                        </div>
                        <div class="value" v-else-if="profile.height === 'ниже среднего'">
                            {{ $t("profileEdit.belowAverage") }}
                        </div>
                        <div class="value" v-else-if="profile.height === 'средний'">
                            {{ $t("profileEdit.medium") }}
                        </div>
                        <div class="value" v-else-if="profile.height === 'выше среднего'">
                            {{ $t("profileEdit.aboveAverage") }}
                        </div>
                        <div class="value" v-else-if="profile.height === 'высокий'">
                            {{ $t("profileEdit.high") }}
                        </div>
                    </li>

                    <li v-if="profile.weight && profile.weight != 0" class="profile-info-item">
                        <div class="property">{{ $t("profile.weight") }}:</div>
                        <!-- <div class="value">{{ profile.weight }}</div> -->
                        <div class="value" v-if="profile.weight === '1'">
                            {{ $t("profileEdit.weight40") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '2'">
                            {{ $t("profileEdit.weight4050") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '3'">
                            {{ $t("profileEdit.weight5060") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '4'">
                            {{ $t("profileEdit.weight6070") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '6'">
                            {{ $t("profileEdit.weight7080") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '7'">
                            {{ $t("profileEdit.weight8090") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '8'">
                            {{ $t("profileEdit.weight90100") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '9'">
                            {{ $t("profileEdit.weight100110") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '10'">
                            {{ $t("profileEdit.weight110120") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '11'">
                            {{ $t("profileEdit.weight120130") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '12'">
                            {{ $t("profileEdit.weight130140") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '13'">
                            {{ $t("profileEdit.weight140150") }}
                        </div>
                        <div class="value" v-else-if="profile.weight === '14'">
                            {{ $t("profileEdit.weight150") }}
                        </div>
                    </li>

                    <li v-if="profile.body_type" class="profile-info-item">
                        <div class="property">{{ $t("profile.bodyImage") }}:</div>
                        <!-- <div class="value">{{ profile.body_type }}</div> -->
                        <div class="value" v-if="profile.body_type === 'худощавое'">
                            {{ $t("profileEdit.skinny") }}
                        </div>
                        <div class="value" v-else-if="profile.body_type === 'обычное'">
                            {{ $t("profileEdit.ordinary") }}
                        </div>
                        <div class="value" v-else-if="profile.body_type === 'спортивное'">
                            {{ $t("profileEdit.athletic") }}
                        </div>
                        <div class="value" v-else-if="profile.body_type === 'мускулистое'">
                            {{ $t("profileEdit.muscular") }}
                        </div>
                        <div class="value" v-else-if="profile.body_type === 'плотное'">
                            {{ $t("profileEdit.dense") }}
                        </div>
                        <div class="value" v-else-if="profile.body_type === 'полное'">
                            {{ $t("profileEdit.complete") }}
                        </div>
                    </li>

                    <li v-if="profile.amount_of_children" class="profile-info-item">
                        <div class="property">{{ $t("profile.children") }}:</div>
                        <!-- <div class="value">{{ profile.amount_of_children }}</div> -->
                        <div class="value" v-if="profile.amount_of_children === 'нет'">
                            {{ $t("profileEdit.childrenNot") }}
                        </div>
                        <div class="value" v-else-if="profile.amount_of_children === 'один ребенок'">
                            {{ $t("profileEdit.childrenOne") }}
                        </div>
                        <div class="value" v-else-if="profile.amount_of_children === 'два ребенка'">
                            {{ $t("profileEdit.childrenTwo") }}
                        </div>
                        <div class="value" v-else-if="profile.amount_of_children === 'три ребенка'">
                            {{ $t("profileEdit.childrenThree") }}
                        </div>
                        <div class="value" v-else-if="profile.amount_of_children === 'больше трех'">
                            {{ $t("profileEdit.childrenMoreFour") }}
                        </div>
                    </li>

                    <li v-if="profile.acquaintance_goal" class="profile-info-item">
                        <div class="property">{{ $t("profile.purposeDating") }}:</div>
                        <!-- <div class="value">{{ profile.acquaintance_goal }}</div> -->
                        <div class="value" v-if="profile.acquaintance_goal === 'дружба, общение'">
                            {{ $t("profileEdit.friendship") }}
                        </div>
                        <div class="value" v-else-if="profile.acquaintance_goal === 'переписка'">
                            {{ $t("profileEdit.correspondence") }}
                        </div>
                        <div class="value" v-else-if="profile.acquaintance_goal === 'отношения'">
                            {{ $t("profileEdit.relationship") }}
                        </div>
                        <div class="value" v-else-if="profile.acquaintance_goal === 'флирт'">
                            {{ $t("profileEdit.flirting") }}
                        </div>
                        <div class="value" v-else-if="profile.acquaintance_goal === 'брак, создание семьи'">
                            {{ $t("profileEdit.marriage") }}
                        </div>
                        <div class="value" v-else-if="profile.acquaintance_goal === 'совместная игра'">
                            {{ $t("profileEdit.coOperativePlay") }}
                        </div>
                    </li>

                    <li v-if="profile.smoking" class="profile-info-item">
                        <div class="property">{{ $t("profile.smoking") }}:</div>
                        <!-- <div class="value">{{ profile.smoking }}</div> -->
                        <div class="value" v-if="profile.smoking === 'не курю'">
                            {{ $t("profileEdit.smokingNot") }}
                        </div>
                        <div class="value" v-else-if="profile.smoking === 'почти не курю'">
                            {{ $t("profileEdit.smokingAlmost") }}
                        </div>
                        <div class="value" v-else-if="profile.smoking === 'бросаю курить'">
                            {{ $t("profileEdit.smokingQuitting") }}
                        </div>
                        <div class="value" v-else-if="profile.smoking === 'курю'">
                            {{ $t("profileEdit.smokingSmoke") }}
                        </div>
                    </li>

                    <li v-if="profile.alcohol" class="profile-info-item">
                        <div class="property">{{ $t("profile.alcohol") }}:</div>
                        <!-- <div class="value">{{ profile.alcohol }}</div> -->
                        <div class="value" v-if="profile.alcohol === 'не пью вообще'">
                            {{ $t("profileEdit.alcoholNot") }}
                        </div>
                        <div class="value" v-else-if="profile.alcohol === 'пью в компаниях изредка'">
                            {{ $t("profileEdit.alcoholCompany") }}
                        </div>
                        <div class="value" v-else-if="profile.alcohol === 'люблю выпить'">
                            {{ $t("profileEdit.alcoholLike") }}
                        </div>
                    </li>

                    <!-- <li v-if="profile.languages && profile.languages.length" class="profile-info-item">
                        <div class="property">{{ $t("profile.languages") }}:</div>
                        <ul class="value">
                            <li v-for="(language, index) in profile.languages" :key="index">
                                {{ language }}
                            </li>
                        </ul>
                    </li> -->

                    <li v-if="profile.languages && profile.languages.length" class="profile-info-item">
                        <div class="property">{{ $t("profile.languages") }}:</div>
                        <ul class="value">
                            <li v-for="(language, index) in profile.languages" :key="index">
                                <div v-if="language === 'Абазинский'">
                                    {{ $t("profileEdit.Abazin") }}
                                </div>
                                <div v-else-if="language === 'Абенаки'">
                                    {{ $t("profileEdit.Abenaki") }}
                                </div>
                                <div v-else-if="language === 'Абхазский'">
                                    {{ $t("profileEdit.Abkhaz") }}
                                </div>
                                <div v-else-if="language === 'Аварский'">
                                    {{ $t("profileEdit.Avar") }}
                                </div>
                                <div v-else-if="language === 'Авестийский'">
                                    {{ $t("profileEdit.Avestan") }}
                                </div>
                                <div v-else-if="language === 'Авнги'">
                                    {{ $t("profileEdit.Avango") }}
                                </div>
                                <div v-else-if="language === 'Агульский'">
                                    {{ $t("profileEdit.Agul") }}
                                </div>
                                <div v-else-if="language === 'Адыгейский'">
                                    {{ $t("profileEdit.Adyghe") }}
                                </div>
                                <div v-else-if="language === 'Азербайджанский'">
                                    {{ $t("profileEdit.Azerbaijani") }}
                                </div>
                                <div v-else-if="language === 'Аймара'">
                                    {{ $t("profileEdit.Aymara") }}
                                </div>
                                <div v-else-if="language === 'Айнийский'">
                                    {{ $t("profileEdit.Ayni") }}
                                </div>
                                <div v-else-if="language === 'Айнский'">
                                    {{ $t("profileEdit.Ainu") }}
                                </div>
                                <div v-else-if="language === 'Аканский'">
                                    {{ $t("profileEdit.Akan") }}
                                </div>
                                <div v-else-if="language === 'Аккадский'">
                                    {{ $t("profileEdit.Akkadian") }}
                                </div>
                                <div v-else-if="language === 'Алабамский'">
                                    {{ $t("profileEdit.Alabama") }}
                                </div>
                                <div v-else-if="language === 'Албанский'">
                                    {{ $t("profileEdit.Albanian") }}
                                </div>
                                <div v-else-if="language === 'Алеутский'">
                                    {{ $t("profileEdit.Aleut") }}
                                </div>
                                <div v-else-if="language === 'Алжирский'">
                                    {{ $t("profileEdit.Algerian") }}
                                </div>
                                <div v-else-if="language === 'Алтайский'">
                                    {{ $t("profileEdit.Altai") }}
                                </div>
                                <div v-else-if="language === 'Амаракери'">
                                    {{ $t("profileEdit.Amaliri") }}
                                </div>
                                <div v-else-if="language === 'Ассамский'">
                                    {{ $t("profileEdit.Assamese") }}
                                </div>
                                <div v-else-if="language === 'Астурийский'">
                                    {{ $t("profileEdit.Asturian") }}
                                </div>
                                <div v-else-if="language === 'Атаяльский'">
                                    {{ $t("profileEdit.Atayal") }}
                                </div>
                                <div v-else-if="language === 'Афарский'">
                                    {{ $t("profileEdit.Afar") }}
                                </div>
                                <div v-else-if="language === 'Африкаанс'">
                                    {{ $t("profileEdit.Afrikaans") }}
                                </div>
                                <div v-else-if="language === 'Ахомский'">
                                    {{ $t("profileEdit.Ahom") }}
                                </div>
                                <div v-else-if="language === 'Багата'">
                                    {{ $t("profileEdit.Bagata") }}
                                </div>
                                <div v-else-if="language === 'Багвалинский'">
                                    {{ $t("profileEdit.Bagvalal") }}
                                </div>
                                <div v-else-if="language === 'Балийский'">
                                    {{ $t("profileEdit.Balinese") }}
                                </div>
                                <div v-else-if="language === 'Бамана (Бамбара)'">
                                    {{ $t("profileEdit.Bambara") }}
                                </div>
                                <div v-else-if="language === 'Банива'">
                                    {{ $t("profileEdit.Baniwa") }}
                                </div>
                                <div v-else-if="language === 'Бантава'">
                                    {{ $t("profileEdit.Bantawa") }}
                                </div>
                                <div v-else-if="language === 'Баскский'">
                                    {{ $t("profileEdit.Basque") }}
                                </div>
                                <div v-else-if="language === 'Белорусский'">
                                    {{ $t("profileEdit.Belarusian") }}
                                </div>
                                <div v-else-if="language === 'Белуджский'">
                                    {{ $t("profileEdit.Balochi") }}
                                </div>
                                <div v-else-if="language === 'Бемба'">
                                    {{ $t("profileEdit.Bemba") }}
                                </div>
                                <div v-else-if="language === 'Бенч'">
                                    {{ $t("profileEdit.Benkha") }}
                                </div>
                                <div v-else-if="language === 'Бикольский'">
                                    {{ $t("profileEdit.Bikol") }}
                                </div>
                                <div v-else-if="language === 'Бислама'">
                                    {{ $t("profileEdit.Bislama") }}
                                </div>
                                <div v-else-if="language === 'Блэкфут'">
                                    {{ $t("profileEdit.Blackfoot") }}
                                </div>
                                <div v-else-if="language === 'Болгарский'">
                                    {{ $t("profileEdit.Bulgarian") }}
                                </div>
                                <div v-else-if="language === 'Бора'">
                                    {{ $t("profileEdit.Bora") }}
                                </div>
                                <div v-else-if="language === 'Боснийский'">
                                    {{ $t("profileEdit.Bosnian") }}
                                </div>
                                <div v-else-if="language === 'Бретонский'">
                                    {{ $t("profileEdit.Breton") }}
                                </div>
                                <div v-else-if="language === 'Будухский'">
                                    {{ $t("profileEdit.Budukh") }}
                                </div>
                                <div v-else-if="language === 'Бурушаски'">
                                    {{ $t("profileEdit.Buruwai") }}
                                </div>
                                <div v-else-if="language === 'Бурятский'">
                                    {{ $t("profileEdit.Buryat") }}
                                </div>
                                <div v-else-if="language === 'Бутанский'">
                                    {{ $t("profileEdit.Bhutanese") }}
                                </div>
                                <div v-else-if="language === 'Бухидский'">
                                    {{ $t("profileEdit.Bugis") }}
                                </div>
                                <div v-else-if="language === 'Бходжпури'">
                                    {{ $t("profileEdit.Bhojpuri") }}
                                </div>
                                <div v-else-if="language === 'Ваи'">
                                    {{ $t("profileEdit.Vai") }}
                                </div>
                                <div v-else-if="language === 'Вайандот'">
                                    {{ $t("profileEdit.Wayampi") }}
                                </div>
                                <div v-else-if="language === 'Валлийский'">
                                    {{ $t("profileEdit.Welsh") }}
                                </div>
                                <div v-else-if="language === 'Валлонский'">
                                    {{ $t("profileEdit.Walloon") }}
                                </div>
                                <div v-else-if="language === 'Варлпири'">
                                    {{ $t("profileEdit.Warlpiri") }}
                                </div>
                                <div v-else-if="language === 'Ваханский'">
                                    {{ $t("profileEdit.Wakhi") }}
                                </div>
                                <div v-else-if="language === 'Венда'">
                                    {{ $t("profileEdit.Wend") }}
                                </div>
                                <div v-else-if="language === 'Венетский'">
                                    {{ $t("profileEdit.Venetian") }}
                                </div>
                                <div v-else-if="language === 'Вепсский'">
                                    {{ $t("profileEdit.Veps") }}
                                </div>
                                <div v-else-if="language === 'Вик-мунгкан'">
                                    {{ $t("profileEdit.VikMungkan") }}
                                </div>
                                <div v-else-if="language === 'Виратури'">
                                    {{ $t("profileEdit.Viraraturi") }}
                                </div>
                                <div v-else-if="language === 'Водский'">
                                    {{ $t("profileEdit.Votic") }}
                                </div>
                                <div v-else-if="language === 'Волапюк'">
                                    {{ $t("profileEdit.Volapuk") }}
                                </div>
                                <div v-else-if="language === 'Выруский'">
                                    {{ $t("profileEdit.Võro") }}
                                </div>
                                <div v-else-if="language === 'Вьетнамский'">
                                    {{ $t("profileEdit.Vietnamese") }}
                                </div>
                                <div v-else-if="language === 'Греческий'">
                                    {{ $t("profileEdit.Greek") }}
                                </div>
                                <div v-else-if="language === 'Грузинский'">
                                    {{ $t("profileEdit.Georgian") }}
                                </div>
                                <div v-else-if="language === 'Гуахиро'">
                                    {{ $t("profileEdit.Waorani") }}
                                </div>
                                <div v-else-if="language === 'Дари'">
                                    {{ $t("profileEdit.Dari") }}
                                </div>
                                <div v-else-if="language === 'Датский'">
                                    {{ $t("profileEdit.Danish") }}
                                </div>
                                <div v-else-if="language === 'Джерсийский'">
                                    {{ $t("profileEdit.Jersey") }}
                                </div>
                                <div v-else-if="language === 'Динка'">
                                    {{ $t("profileEdit.Dinka") }}
                                </div>
                                <div v-else-if="language === 'Долуо'">
                                    {{ $t("profileEdit.Doluo") }}
                                </div>
                                <div v-else-if="language === 'Дуала'">
                                    {{ $t("profileEdit.Duala") }}
                                </div>
                                <div v-else-if="language === 'Дусунский'">
                                    {{ $t("profileEdit.Dusun") }}
                                </div>
                                <div v-else-if="language === 'Египетский диалект арабского'">
                                    {{ $t("profileEdit.EgyptianArabic") }}
                                </div>
                                <div v-else-if="language === 'Западнофризский'">
                                    {{ $t("profileEdit.WestFrisian") }}
                                </div>
                                <div v-else-if="language === 'Ибанский'">
                                    {{ $t("profileEdit.Iban") }}
                                </div>
                                <div v-else-if="language === 'Иврит'">
                                    {{ $t("profileEdit.Hebrew") }}
                                </div>
                                <div v-else-if="language === 'Ижорский'">
                                    {{ $t("profileEdit.Izhora") }}
                                </div>
                                <div v-else-if="language === 'Илоканский'">
                                    {{ $t("profileEdit.Ilokano") }}
                                </div>
                                <div v-else-if="language === 'Ингушский'">
                                    {{ $t("profileEdit.Ingush") }}
                                </div>
                                <div v-else-if="language === 'Индонезийский'">
                                    {{ $t("profileEdit.Indonesian") }}
                                </div>
                                <div v-else-if="language === 'Ирландский'">
                                    {{ $t("profileEdit.Irish") }}
                                </div>
                                <div v-else-if="language === 'Исландский'">
                                    {{ $t("profileEdit.Icelandic") }}
                                </div>
                                <div v-else-if="language === 'Испанский'">
                                    {{ $t("profileEdit.Spanish") }}
                                </div>
                                <div v-else-if="language === 'Итальянский'">
                                    {{ $t("profileEdit.Italian") }}
                                </div>
                                <div v-else-if="language === 'Кабардино-черкесский'">
                                    {{ $t("profileEdit.Kabardian") }}
                                </div>
                                <div v-else-if="language === 'Кабильский'">
                                    {{ $t("profileEdit.Kabyle") }}
                                </div>
                                <div v-else-if="language === 'Кабувердьяну'">
                                    {{ $t("profileEdit.Kabuverdianu") }}
                                </div>
                                <div v-else-if="language === 'Каинганг'">
                                    {{ $t("profileEdit.Kaingang") }}
                                </div>
                                <div v-else-if="language === 'Кайюга'">
                                    {{ $t("profileEdit.Cayuga") }}
                                </div>
                                <div v-else-if="language === 'Калмыцкий'">
                                    {{ $t("profileEdit.Kalmyk") }}
                                </div>
                                <div v-else-if="language === 'Канури'">
                                    {{ $t("profileEdit.Kanuri") }}
                                </div>
                                <div v-else-if="language === 'Капампанган'">
                                    {{ $t("profileEdit.Kapampangan") }}
                                </div>
                                <div v-else-if="language === 'Караимский'">
                                    {{ $t("profileEdit.Karaite") }}
                                </div>
                                <div v-else-if="language === 'Каракалпакский'">
                                    {{ $t("profileEdit.Karakalpak") }}
                                </div>
                                <div v-else-if="language === 'Карамоджонг'">
                                    {{ $t("profileEdit.Karamojong") }}
                                </div>
                                <div v-else-if="language === 'Карачаево-балкарский'">
                                    {{ $t("profileEdit.KarachayBalkar") }}
                                </div>
                                <div v-else-if="language === 'Карельский'">
                                    {{ $t("profileEdit.Karelian") }}
                                </div>
                                <div v-else-if="language === 'Карийский'">
                                    {{ $t("profileEdit.Carian") }}
                                </div>
                                <div v-else-if="language === 'Каталанский'">
                                    {{ $t("profileEdit.Catalan") }}
                                </div>
                                <div v-else-if="language === 'Кекчи'">
                                    {{ $t("profileEdit.Kekchi") }}
                                </div>
                                <div v-else-if="language === 'Кельтиберский'">
                                    {{ $t("profileEdit.Celtiberian") }}
                                </div>
                                <div v-else-if="language === 'Кечуа'">
                                    {{ $t("profileEdit.Quechua") }}
                                </div>
                                <div v-else-if="language === 'Китайский'">
                                    {{ $t("profileEdit.Chinese") }}
                                </div>
                                <div v-else-if="language === 'Команчский'">
                                    {{ $t("profileEdit.Comanche") }}
                                </div>
                                <div v-else-if="language === 'Коптский'">
                                    {{ $t("profileEdit.Coptic") }}
                                </div>
                                <div v-else-if="language === 'Корейский'">
                                    {{ $t("profileEdit.Korean") }}
                                </div>
                                <div v-else-if="language === 'Корнский'">
                                    {{ $t("profileEdit.Cornish") }}
                                </div>
                                <div v-else-if="language === 'Кофан'">
                                    {{ $t("profileEdit.Cofán") }}
                                </div>
                                <div v-else-if="language === 'Кхмерский'">
                                    {{ $t("profileEdit.Khmer") }}
                                </div>
                                <div v-else-if="language === 'Ладинский'">
                                    {{ $t("profileEdit.Ladin") }}
                                </div>
                                <div v-else-if="language === 'Лазский'">
                                    {{ $t("profileEdit.Laz") }}
                                </div>
                                <div v-else-if="language === 'Лезгинский'">
                                    {{ $t("profileEdit.Lezgian") }}
                                </div>
                                <div v-else-if="language === 'Ливанский'">
                                    {{ $t("profileEdit.Lebanese") }}
                                </div>
                                <div v-else-if="language === 'Литовский'">
                                    {{ $t("profileEdit.Lithuanian") }}
                                </div>
                                <div v-else-if="language === 'Македонский'">
                                    {{ $t("profileEdit.Macedonian") }}
                                </div>
                                <div v-else-if="language === 'Мальдивский'">
                                    {{ $t("profileEdit.Maldivian") }}
                                </div>
                                <div v-else-if="language === 'Монгольский'">
                                    {{ $t("profileEdit.Mongolian") }}
                                </div>
                                <div v-else-if="language === 'Немецкий'">
                                    {{ $t("profileEdit.German") }}
                                </div>
                                <div v-else-if="language === 'Нидерландский'">
                                    {{ $t("profileEdit.Dutch") }}
                                </div>
                                <div v-else-if="language === 'Норвежский'">
                                    {{ $t("profileEdit.Norwegian") }}
                                </div>
                                <div v-else-if="language === 'Оромо'">
                                    {{ $t("profileEdit.Oromo") }}
                                </div>
                                <div v-else-if="language === 'Персидский'">
                                    {{ $t("profileEdit.Persian") }}
                                </div>
                                <div v-else-if="language === 'Польский'">
                                    {{ $t("profileEdit.Polish") }}
                                </div>
                                <div v-else-if="language === 'Португальский'">
                                    {{ $t("profileEdit.Portuguese") }}
                                </div>
                                <div v-else-if="language === 'Румынский'">
                                    {{ $t("profileEdit.Romanian") }}
                                </div>
                                <div v-else-if="language === 'Русский'">
                                    {{ $t("profileEdit.Russian") }}
                                </div>
                                <div v-else-if="language === 'Себуанский'">
                                    {{ $t("profileEdit.Cebuano") }}
                                </div>
                                <div v-else-if="language === 'Сербский'">
                                    {{ $t("profileEdit.Serbian") }}
                                </div>
                                <div v-else-if="language === 'Сефардский'">
                                    {{ $t("profileEdit.Sephardic") }}
                                </div>
                                <div v-else-if="language === 'Сирийский'">
                                    {{ $t("profileEdit.Syriac") }}
                                </div>
                                <div v-else-if="language === 'Трукский (чуукский)'">
                                    {{ $t("profileEdit.Trukese") }}
                                </div>
                                <div v-else-if="language === 'Турецкий'">
                                    {{ $t("profileEdit.Turkish") }}
                                </div>
                                <div v-else-if="language === 'Туркменский'">
                                    {{ $t("profileEdit.Turkmen") }}
                                </div>
                                <div v-else-if="language === 'Уаб-мето'">
                                    {{ $t("profileEdit.WaAb") }}
                                </div>
                                <div v-else-if="language === 'Удмуртский'">
                                    {{ $t("profileEdit.Udmurt") }}
                                </div>
                                <div v-else-if="language === 'Узбекский'">
                                    {{ $t("profileEdit.Uzbek") }}
                                </div>
                                <div v-else-if="language === 'Украинский'">
                                    {{ $t("profileEdit.Ukrainian") }}
                                </div>
                                <div v-else-if="language === 'Уме-саамский'">
                                    {{ $t("profileEdit.UmeSami") }}
                                </div>
                                <div v-else-if="language === 'Урду'">
                                    {{ $t("profileEdit.Urdu") }}
                                </div>
                                <div v-else-if="language === 'Финский'">
                                    {{ $t("profileEdit.Finnish") }}
                                </div>
                                <div v-else-if="language === 'Французский'">
                                    {{ $t("profileEdit.French") }}
                                </div>
                                <div v-else-if="language === 'Хорватский'">
                                    {{ $t("profileEdit.Croatian") }}
                                </div>
                                <div v-else-if="language === 'Цимбрский'">
                                    {{ $t("profileEdit.Zimbran") }}
                                </div>
                                <div v-else-if="language === 'Чавакано'">
                                    {{ $t("profileEdit.Chavacano") }}
                                </div>
                                <div v-else-if="language === 'Чакма'">
                                    {{ $t("profileEdit.Chakma") }}
                                </div>
                                <div v-else-if="language === 'Чамалинский'">
                                    {{ $t("profileEdit.Chamalins") }}
                                </div>
                                <div v-else-if="language === 'Чаморро'">
                                    {{ $t("profileEdit.Chamorro") }}
                                </div>
                                <div v-else-if="language === 'Чамский'">
                                    {{ $t("profileEdit.Chamic") }}
                                </div>
                                <div v-else-if="language === 'Чаха'">
                                    {{ $t("profileEdit.Chaha") }}
                                </div>
                                <div v-else-if="language === 'Чева'">
                                    {{ $t("profileEdit.Cheva") }}
                                </div>
                                <div v-else-if="language === 'Чеченский'">
                                    {{ $t("profileEdit.Chechen") }}
                                </div>
                                <div v-else-if="language === 'Чешский'">
                                    {{ $t("profileEdit.Czech") }}
                                </div>
                                <div v-else-if="language === 'Чикасо'">
                                    {{ $t("profileEdit.Chickasaw") }}
                                </div>
                                <div v-else-if="language === 'Чипевиан'">
                                    {{ $t("profileEdit.Chipewyan") }}
                                </div>
                                <div v-else-if="language === 'Чоктавский'">
                                    {{ $t("profileEdit.Choctaw") }}
                                </div>
                                <div v-else-if="language === 'Чувашский'">
                                    {{ $t("profileEdit.Chuvash") }}
                                </div>
                                <div v-else-if="language === 'Чукотский'">
                                    {{ $t("profileEdit.Chukchi") }}
                                </div>
                                <div v-else-if="language === 'Шайенский'">
                                    {{ $t("profileEdit.Shoshone") }}
                                </div>
                                <div v-else-if="language === 'Шведский'">
                                    {{ $t("profileEdit.Swedish") }}
                                </div>
                                <div v-else-if="language === 'Эльзасский диалект'">
                                    {{ $t("profileEdit.Alsatian") }}
                                </div>
                                <div v-else-if="language === 'Эстонский'">
                                    {{ $t("profileEdit.Estonian") }}
                                </div>
                                <div v-else-if="language === 'Эстремадурский'">
                                    {{ $t("profileEdit.Extremaduran") }}
                                </div>
                                <div v-else-if="language === 'Ямайский'">
                                    {{ $t("profileEdit.JamaicanPatois") }}
                                </div>
                                <div v-else-if="language === 'Яо'">
                                    {{ $t("profileEdit.Yao") }}
                                </div>
                                <div v-else-if="language === 'Японский'">
                                    {{ $t("profileEdit.Japanese") }}
                                </div>
                            </li>

                        </ul>
                    </li>


                    <li v-if="profile.about" class="profile-info-item">
                        <div class="property">{{ $t("profile.aboutMyself") }}:</div>
                        <div class="value">{{ profile.about }}</div>
                    </li>

                </ul>
            </div>
        </div>
    </section>
    <section v-else-if="isBlacklist">
        <div class="no-auth">
            {{ $t("profile.userRestrictedAccessPage") }}
        </div>
    </section>
    <section v-else>
        <div class="no-auth">
            {{ $t("auth.wasAnError") }}
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDateTime } from "@/mixins/formatDateTime";
import redirectButton from "@/components/Buttons/Redirect";
import InviteToGame from "@/components/Blocks/InviteToGame";
import ProfileMedia from "@/components/Blocks/ProfileMedia";
import ProfilePuzzles from "@/components/Blocks/ProfilePuzzles";
import { declineNouns } from "@/mixins/declineNouns";
import { getZodiac } from "@/mixins/getZodiac";
import { clickOutside } from "@/directives.js";
import Vue from "vue";

export default {
    name: "Profile",
    props: {
        i18n: Object,
    },
    props: {
        ownerId: {
            type: [Number, String],
            required: false,
        },
    },
    components: {
        redirectButton,
        InviteToGame,
        ProfileMedia,
        ProfilePuzzles,
    },
    mixins: [formatDateTime, declineNouns, getZodiac],
    data() {
        return {
            id: "",
            showContext: false,
            showInfoAll: false,
            showGames: false,
            pageLoader: true,
            // photosLoader: true,
            giftsLoader: true,
            friendsLoader: false,
            guestsLoader: true,
            // inviteToGameLoader: false,
            statusEdit: false,
            statusLoader: false,
            // friendsLoader: false,
            blacklistLoader: false,
            tempStatus: {},
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            profile: "profile/fetchProfile",
            profileIsEmpty: "profile/isEmpty",
            // photos: 'photos/fetchPhotos',
            // photosIsEmpty: 'photos/isEmpty',
            // photosErrors: 'photos/errors',
            // count: 'photos/fetchPhotosCount',
            isBlacklist: "profile/fetchIsBlacklist",
            // myGifts: 'gifts/fetchMyGifts',
            friends: "friends/fetchFriends",
            friendsCount: "friends/fetchFriendsCount",
            friendsIsEmpty: "friends/isEmpty",
            friendsErrors: "friends/errors",
            guests: "guests/fetchGuests",
            guestsCount: "guests/fetchGuestsCount",
            guestsIsEmpty: "guests/isEmpty",
            guestsErrors: "guests/errors",
            userGifts: "gifts/fetchUserGifts",
            giftsCount: "gifts/fetchGiftsCount",
            giftsIsEmpty: "gifts/isEmpty",
        }),
        age() {
            let bDateArr = this.profile.birthday.split(".");
            let bDate = new Date();
            bDate.setDate(bDateArr[0]);
            bDate.setMonth(bDateArr[1] - 1);
            bDate.setFullYear(bDateArr[2]);
            bDate = bDate.getTime();
            let years = new Date(+new Date() - bDate).getFullYear() - 1970;
            return years;
        },
        zodiac() {
            let day = parseInt(this.profile.birthday.slice(0, 2));
            let month = parseInt(this.profile.birthday.slice(3, 5));
            return this.getZodiac(day, month);
        },
        localStatus: function () {
            if (Object.keys(this.tempStatus).length) {
                return this.tempStatus;
            }
            this.tempStatus = { status: this.user.status };
            return this.tempStatus;
        },
        limitedFriends() {
            return this.friends.slice(0, 6);
        },
        limitedGuests() {
            return this.guests.slice(0, 6);
        },
    },
    created() {
        this.pageLoader = true;
        this.$store.dispatch("profile/clearProfile");
        this.id =
            this.$route.params && this.$route.params.id
                ? this.$route.params.id
                : this.ownerId;
        this.get();
        this.getGifts();
        // this.getPhotos();
        this.getFriends();
        this.getGuests();
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.pageLoader = true;
                this.$store.dispatch("profile/clearProfile");
                // this.photosLoader = true;
                this.friendsLoader = true;
                this.guestsLoader = true;
                this.showContext = false;
                this.id =
                    this.$route.params && this.$route.params.id
                        ? this.$route.params.id
                        : this.ownerId;
                this.get();
                this.getGifts();
                // this.getPhotos();
                this.getFriends();
                this.getGuests();
                this.showInfoAll = false;
            }
        },
    },
    methods: {
        get() {
            this.$store
                .dispatch("profile/get", this.id)
                .then(() => {
                    this.pageLoader = false;
                })
                .catch((err) => {
                    //console.log(err);
                    this.pageLoader = false;
                });
        },
        getGifts() {
            this.$nextTick(() => {
                let action =
                    this.id == this.user.id ? "gifts/getMyGifts" : "gifts/getUserGifts";
                this.$store
                    .dispatch(action, this.id)
                    .then(() => {
                        this.giftsLoader = false;
                    })
                    .catch(() => {
                        this.giftsLoader = false;
                    });
            });
        },
        getFriends() {
            if (this.userIsEmpty("user")) return;
            let action, payload;
            if (this.id == this.user.id) {
                action = "friends/get";
                payload = false;
            } else {
                action = "friends/profileGet";
                payload = [this.id, ""];
            }
            this.$store
                .dispatch(action, payload)
                .then(() => {
                    this.friendsLoader = false;
                })
                .catch(() => {
                    this.friendsLoader = false;
                });
        },
        getGuests() {
            if (this.userIsEmpty("user")) return;
            this.$store
                .dispatch("guests/get")
                .then(() => {
                    this.guestsLoader = false;
                })
                .catch(() => {
                    this.guestsLoader = false;
                });
        },
        // getPhotos() {
        //     this.$store.dispatch('photos/getAll', this.id)
        //     .then(() => {
        //         this.photosLoader = false;
        //     })
        //     .catch(() => {
        //         this.photosLoader = false;
        //     });
        // },
        addToFriends() {
            if (this.userIsEmpty("user")) {
                this.$modal.show("welcome");
                return;
            }
            this.friendsLoader = true;
            this.$store
                .dispatch("profile/addToFriends", this.$route.params.id)
                .then(() => {
                    this.friendsLoader = false;
                    this.$modal.show("dialog", {
                        title: this.$t("myFriends.success"),
                        text: this.$t("myFriends.friendRequestSent"),
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                    // Немедленно обновляем тип для реактивности UI
                    if (this.profile && this.profile.is_friend) {
                        this.$set(this.profile.is_friend, "type", 1);
                    }
                    this.get();
                    this.showContext = false;
                })
                .catch(() => {
                    this.friendsLoader = false;
                });
        },
        cancelAddFriends() {
            if (this.userIsEmpty("user")) {
                this.$modal.show("welcome");
                return;
            }
            this.friendsLoader = true;
            this.$store
                .dispatch("friendsOutgoing/cancelAddFriends", this.$route.params.id)
                .then(() => {
                    this.friendsLoader = false;
                    this.$modal.show("dialog", {
                        title: this.$t("myFriends.success"),
                        text: this.$t("myFriends.applicationCancelled"),
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                    // Немедленно обновляем тип для реактивности UI
                    if (this.profile && this.profile.is_friend) {
                        this.$set(this.profile.is_friend, "type", 0);
                    }
                    this.get();
                    this.showContext = false;
                })
                .catch(() => {
                    this.friendsLoader = false;
                });
        },
        removeFriend() {
            this.friendsLoader = true;
            this.$store
                .dispatch("friends/remove", this.$route.params.id)
                .then(() => {
                    this.friendsLoader = false;
                    this.$modal.show("dialog", {
                        title: this.$t("myFriends.success"),
                        text: this.$t("myFriends.friendSuccessfullyDeleted"),
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                    // Немедленно обновляем тип для реактивности UI
                    if (this.profile && this.profile.is_friend) {
                        this.$set(this.profile.is_friend, "type", 0);
                    }
                    this.get();
                    this.showContext = false;
                })
                .catch(() => {
                    this.friendsLoader = false;
                });
        },
        acceptFriend() {
            this.friendsLoader = true;
            this.$store
                .dispatch("friendsIncoming/accept", this.$route.params.id)
                .then(() => {
                    this.friendsLoader = false;
                    this.$modal.show("dialog", {
                        title: this.$t("myFriends.success"),
                        text: this.$t("myFriends.offerFriendshipAccepted"),
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                    // Немедленно обновляем тип для реактивности UI
                    if (this.profile && this.profile.is_friend) {
                        this.$set(this.profile.is_friend, "type", 2);
                    }
                    this.get();
                    this.showContext = false;
                })
                .catch(() => {
                    this.friendsLoader = false;
                });
        },
        blacklist(add) {
            let action, warning, success;
            if (add) {
                action = "profile/addToBlacklist";
                warning = this.$t("profile.UserWillAddedBlacklist");
                success = this.$t("profile.userBlocked");
            } else {
                action = "blacklist/remove";
                warning = this.$t("profile.userWillRemovedBlacklist");
                success = this.$t("profile.userUnlocked");
            }

            this.$modal.show("dialog", {
                title: this.$t("threads.warning"),
                text: warning,
                buttons: [
                    {
                        title: this.$t("stories.continue"),
                        handler: () => {
                            this.$modal.hide("dialog");
                            this.blacklistLoader = true;
                            this.$store
                                .dispatch(action, this.id)
                                .then(() => {
                                    this.blacklistLoader = false;
                                    this.showContext = false;
                                    this.$modal.show("dialog", {
                                        title: this.$t("myFriends.success"),
                                        text: success,
                                        buttons: [
                                            {
                                                title: this.$t("roulette.ok"),
                                            },
                                        ],
                                    });
                 
                                    this.get();
                                })
                                .catch(() => {
                                    this.blacklistLoader = false;
                                    this.showContext = false;
                                });
                        },
                    },
                    {
                        title: this.$t("settings.cancel"),
                        handler: () => {
                            this.$modal.hide("dialog");
                        },
                    },
                ],
            });
        },
        updated(event) {
            this.$set(this.tempStatus, event.target.id, event.target.value);
        },
        saveStatus() {
            this.statusEdit = false;
            if (this.localStatus.status == this.user.status || this.statusLoader) {
                return;
            }
            this.statusLoader = true;
            this.$store
                .dispatch("user/saveProfile", [this.localStatus, true])
                .then(() => {
                    this.statusLoader = false;
                    this.statusEdit = false;
                })
                .catch(() => {
                    this.statusLoader = false;
                    this.statusEdit = false;
                });
        },
        sendMessage(id) {
            if (this.userIsEmpty("user")) {
                this.$modal.show("welcome");
                return;
            }
            this.showContext = false;
            if (
                this.profile.vip &&
                this.profile.vip_settings.messages == 1 &&
                this.profile.is_friend.type != 2 &&
                !this.user.vip
            ) {
                this.$modal.show("dialog", {
                    title: this.$t("threads.mistake"),
                    text: this.$t("profile.youCantWriteUser"),
                    buttons: [
                        {
                            title: this.$t("roulette.ok"),
                        },
                    ],
                });
            } else {
                this.$router.push({ name: "threads", params: { id: id } });
            }
        },
        sendGift() {
            if (this.userIsEmpty("user")) {
                this.$modal.show("welcome");
            } else {
                this.$modal.show("gifts-list", { id: this.id });
            }
        },
        clickOutsideStatus() {
            this.tempStatus = { status: this.user.status };
            this.statusEdit = false;
        },
        clickInsideStatus() {
            this.statusEdit = true;
        },
        clickOutsideGames() {
            this.showGames = false;
        },
        clickOutsideContext() {
            this.showContext = false;
        },
        // isEducations(type) {
        //     let educations = type == 'secondary' ? true : false;
        //     for (let i in this.profile.educations) {
        //         if (this.profile.educations[i].education_type === educations) {
        //             return true;
        //         }
        //     }
        //     return false;
        // }
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/pages/_profile";
</style>
